<template>
  <div class="checkout-step__section">
    <div class="section-heading" style="margin-bottom: 18px;">
      <span class="section-heading__eyebrow">Ticket tiers</span>
      <h2 class="section-heading__title">Localidades y condiciones</h2>
      <p class="section-heading__text">
        Revisa disponibilidad, precios y descripciones antes de pasar al siguiente paso del checkout.
      </p>
    </div>

    <div v-if="eventType == 2 && eventTickets.length == 0" class="shell-empty-state">
      Para adquirir este evento debes ser invitado por un promotor, auspiciante o tener un codigo de acceso.
    </div>

    <div v-else class="checkout-step__table">
      <div class="ticket-tier-grid">
        <article
          v-for="(eventTicket, index) in eventTickets"
          :key="index"
          :class="['ticket-tier-card', { 'is-courtesy': eventTicket.is_courtesy }]"
        >
          <div class="ticket-tier-card__top">
            <div>
              <span class="ticket-tier-card__eyebrow">Localidad</span>
              <h3 class="ticket-tier-card__title">{{ eventTicket.name }}</h3>
            </div>

            <div class="ticket-tier-card__price">
              <span v-if="eventTicket.is_courtesy">Cortesia</span>
              <span v-else>${{ eventTicket.price }}</span>
            </div>
          </div>

          <p class="ticket-tier-card__description">
            {{ eventTicket.description || 'Cupos limitados con validacion en tiempo real.' }}
          </p>

          <div class="ticket-tier-card__footer">
            <span>{{ eventTicket.is_courtesy ? 'Acceso validado por invitacion' : 'Compra directa disponible' }}</span>
            <span v-if="eventTicket.max_quantity">Max {{ eventTicket.max_quantity }} por orden</span>
          </div>
        </article>
      </div>

      <p class="checkout-step__inline-note">
        La disponibilidad se actualiza en tiempo real. Si ves un tier activo, conviene cerrar la compra antes de que cambie de precio o se agote.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventViewDetail',

  props: {
    updatesProp: {
      type: Object,
    },
    eventTickets: {
      type: Array,
    },
    eventType: {
      required: true,
    },
  },
}
</script>

<style>
</style>
